import { render, staticRenderFns } from "./reduction.vue?vue&type=template&id=130dcf54&scoped=true&"
import script from "./reduction.vue?vue&type=script&lang=ts&"
export * from "./reduction.vue?vue&type=script&lang=ts&"
import style0 from "./reduction.vue?vue&type=style&index=0&id=130dcf54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130dcf54",
  null
  
)

component.options.__file = "reduction.vue"
export default component.exports